import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListaPaginada, TarifarioRodoviario } from "../../../model";
import { API } from "../../../app.config";

@Injectable({
    providedIn: "root",
})
export class TarifarioService {
    constructor(private http: HttpClient) {}

    getAll(parametroBusca: string): Observable<ListaPaginada<TarifarioRodoviario>> {
        parametroBusca = encodeURIComponent(parametroBusca || "");
        return this.http.get<ListaPaginada<TarifarioRodoviario>>(
            `${API}/api/tarifariorodoviario/list?q=${parametroBusca}`
        );
    }

    getById(id: number): Observable<ListaPaginada<TarifarioRodoviario>> {
        return this.http.get<ListaPaginada<TarifarioRodoviario>>(`${API}/api/tarifariorodoviario/${id}`);
    }

    post(tarifario: TarifarioRodoviario): Observable<TarifarioRodoviario> {
        return this.http.post<TarifarioRodoviario>(`${API}/api/tarifariorodoviario`, tarifario);
    }

    put(tarifario: TarifarioRodoviario): Observable<TarifarioRodoviario> {
        return this.http.put<TarifarioRodoviario>(`${API}/api/tarifariorodoviario/${tarifario.Id}`, tarifario);
    }

    delete(id: number): Observable<TarifarioRodoviario> {
        return this.http.delete<TarifarioRodoviario>(`${API}/api/tarifariorodoviario/${id}`);
    }
}
